/* ============================================================
   BONHEUR - Pagina de coleccion
   BigStudio 2026

   UNA SOLA TAREA, Y ES UNA CORRECCION
   El filtro "Disponibilidad" que la tienda ofrece hoy MIENTE. El
   inventario no se controla, asi que los 31 productos reportan
   cero unidades y Shopify los clasifica como agotados. La clienta
   ve "Agotado" sobre piezas que estan en la vitrina de La Dehesa.

   La correccion de verdad es apagarlo en el app Search and
   Discovery: un clic, sin codigo. Pero eso toca la tienda
   PUBLICADA, asi que no se hace desde aqui. Mientras tanto este
   archivo lo esconde solo en este tema, para poder mostrar la
   pagina sin ese error.

   El dia que se apague en el app, este archivo deja de encontrar
   nada y no hace nada. No hay que volver a tocarlo.
   ============================================================ */

(function () {
  'use strict';

  /* Se compara sin acentos y en minusculas: el rotulo lo entrega
     Shopify traducido y puede llegar con o sin tilde. */
  var OCULTAR = ['disponibilidad', 'availability'];

  function normal(t) {
    return (t || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .trim();
  }

  function podar(raiz) {
    var grupos = (raiz || document).querySelectorAll('.facets__item, .facets__panel');
    for (var i = 0; i < grupos.length; i++) {
      var g = grupos[i];
      if (g.classList.contains('bh-sin-disponibilidad')) continue;

      var rotulo = g.querySelector('.facets__label, .facets__summary, summary');
      if (!rotulo) continue;

      var t = normal(rotulo.textContent);
      for (var j = 0; j < OCULTAR.length; j++) {
        if (t.indexOf(OCULTAR[j]) === 0) {
          g.classList.add('bh-sin-disponibilidad');
          break;
        }
      }
    }
  }

  function arrancar() {
    podar(document);

    /* Los filtros se redibujan con la Section Rendering API en
       cada cambio, asi que hay que volver a podar. */
    if ('MutationObserver' in window) {
      var pendiente = false;
      new MutationObserver(function (muts) {
        if (pendiente) return;
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes.length) {
            pendiente = true;
            requestAnimationFrame(function () {
              pendiente = false;
              podar(document);
            });
            return;
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  document.addEventListener('shopify:section:load', function (e) { podar(e.target); });
})();
